import config from "@config/config";
import { firebaseInstance } from "./api";

export const getUserTickets = async (userID) => {
  const id = userID ?? "";
  try {
    const response = await firebaseInstance.get(
      `app/get-user-tickets?userID=${id}`
    );
    return response.data;
  } catch (error) {
    if (error.response) {
      // console.log("Error response:", error.response);
    } else if (error.request) {
      // console.log("Error request:", error.request);
    } else if (error.message) {
      // console.log("Error message:", error.message);
    }
    // re-throw the error so react-query can catch it
    throw error;
  }
};

export const deleteRequest = async (requestID) => {
  const id = requestID ?? "";
  try {
    const response = await firebaseInstance.post(
      `app/delete-guestlist-request`,
      {
        requestID: id,
      }
    );
    return response;
  } catch (error) {
    if (error.response) {
      // console.log("Error response:", error.response);
    } else if (error.request) {
      // console.log("Error request:", error.request);
    } else if (error.message) {
      // console.log("Error message:", error.message);
    }
    // re-throw the error so react-query can catch it
    throw error;
  }
};

export const getTicketByScanCodeID = async (scanCodeID) => {
  const id = scanCodeID ?? "";
  try {
    const response = await firebaseInstance.get(
      `app/get-user-tickets?scanCodeID=${id}`
    );
    return response.data;
  } catch (error) {
    if (error.response) {
      // console.log("Error response:", error.response);
    } else if (error.request) {
      // console.log("Error request:", error.request);
    } else if (error.message) {
      // console.log("Error message:", error.message);
    }
    // re-throw the error so react-query can catch it
    throw error;
  }
};

export const updateUserModel = async (
  uid,
  idToken,
  refreshToken,
  dob,
  phoneNumber,
  firstName,
  lastName,
  userName,
  address,
  imageUrl,
  gender
) => {
  try {
    const response = await firebaseInstance.post(`app/update-user-info`, {
      uid,
      idToken,
      refreshToken,
      firstName,
      lastName,
      dob,
      userName,
      address,
      phoneNumber,
      imageUrl,
      gender,
    });

    return response.data;
  } catch (error) {
    if (error.response) {
      // console.log("Error response:", error.response);
    } else if (error.request) {
      // console.log("Error request:", error.request);
    } else if (error.message) {
      // console.log("Error message:", error.message);
    }
    // re-throw the error so react-query can catch it
    throw error;
  }
};
